import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export async function getOrganizationById() {
  // id from token
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.getOrganizationByIds, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateOrganization(body: any) {
  // id from token
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEORGANIZATION, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addOrganization(body: any) {
  // id from token
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDUPDATEORGANIZATION, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}